ceregoCommon.factory('V3SeriesResource', ['$resource', ($resource) ->
  $resource "", {},
    get:
      method: 'GET'
      isArray: false
      url: APIRoutes.v3_series_path(":id")
      params:
        group_id: "@id"
])
